export class ProjectNavigationState {
    selectedView = 'info';// info , questionnaires
    questionnaireId =  0;
}
